import { DOWNLOAD_CSV_URL } from '../config';
import axios from 'axios';

export function downloadCSV(data) {
  return axios.post(`${DOWNLOAD_CSV_URL}/generate/csv`, data)
    .then(response => {
      return response.data;
    });
}
